import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  category: string;
  publishDate: string;
  readTime: string;
  image: string;
  tags: string[];
}

export default function ArticleCard({ title, slug, excerpt, category, publishDate, readTime, image, tags }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={image}
          alt={title}
          title={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs bg-primary-100 text-primary-700 px-2.5 py-1 rounded-full font-medium">
            {category}
          </span>
          <span className="text-xs text-foreground-500">{publishDate}</span>
          <span className="text-xs text-foreground-500">· {readTime}</span>
        </div>
        <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 leading-snug">
          <Link to={`/article/${slug}`} className="hover:text-primary-600 transition-colors">
            {title}
          </Link>
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
          {excerpt}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex flex-wrap gap-1.5">
            {tags.slice(0, 2).map((tag, i) => (
              <span key={i} className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                #{tag}
              </span>
            ))}
          </div>
          <Link
            to={`/article/${slug}`}
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            阅读全文 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}